import { AllMyCruisesProps } from '@msc-b2c/interfaces/types';
import AllMyCruises from './AllMyCruises';
import { useGetAllCruises } from './AllMyCruises.hooks';
import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';

export function AllMyCruisesWrapper({
  youSetSailLabel,
  youSetSailDaysLabel,
  statusLabel,
  bookedLabel,
  paidBalanceLabel,
  positiveBalanceLabel,
  negativeBalanceLabel,
  paidBalanceDescription,
  positiveBalanceDescription,
  negativeBalanceDescription,
  bookingNumberLabel,
  itineraryButtonLabel,
  itineraryButtonLink,
  viewBookingDetailsLabel,
  bookingTitleLabel,
  bookingSubtitleLabel,
  dateRangeFormatSameMonthSameYear,
  dateRangeFormatDifferentMonthSameYear,
  dateRangeFormatDifferentYear,
  stateroomLabel,
  stateroomDescription,
  onewayLabel,
  onewayDescription,
  roundtripLabel,
  roundtripDescription,
  visitingLabel,
  visitingDescriptionSeparator,
  dayFieldLabel,
  nightFieldLabel,
  passengerFieldLabel,
}: Readonly<AllMyCruisesProps>) {
  const genericConfigs = useSelector((state: RootState) => state.genericConfigs);

  const cruisesData = useGetAllCruises(genericConfigs);

  return (
    <AllMyCruises
      youSetSailLabel={youSetSailLabel}
      youSetSailDaysLabel={youSetSailDaysLabel}
      statusLabel={statusLabel}
      bookedLabel={bookedLabel}
      paidBalanceLabel={paidBalanceLabel}
      positiveBalanceLabel={positiveBalanceLabel}
      negativeBalanceLabel={negativeBalanceLabel}
      paidBalanceDescription={paidBalanceDescription}
      positiveBalanceDescription={positiveBalanceDescription}
      negativeBalanceDescription={negativeBalanceDescription}
      bookingNumberLabel={bookingNumberLabel}
      itineraryButtonLabel={itineraryButtonLabel}
      itineraryButtonLink={itineraryButtonLink}
      viewBookingDetailsLabel={viewBookingDetailsLabel}
      bookingTitleLabel={bookingTitleLabel}
      bookingSubtitleLabel={bookingSubtitleLabel}
      dateRangeFormatSameMonthSameYear={dateRangeFormatSameMonthSameYear}
      dateRangeFormatDifferentMonthSameYear={dateRangeFormatDifferentMonthSameYear}
      dateRangeFormatDifferentYear={dateRangeFormatDifferentYear}
      stateroomLabel={stateroomLabel}
      stateroomDescription={stateroomDescription}
      onewayLabel={onewayLabel}
      onewayDescription={onewayDescription}
      roundtripLabel={roundtripLabel}
      roundtripDescription={roundtripDescription}
      visitingLabel={visitingLabel}
      visitingDescriptionSeparator={visitingDescriptionSeparator}
      dayFieldLabel={dayFieldLabel}
      nightFieldLabel={nightFieldLabel}
      passengerFieldLabel={passengerFieldLabel}
      cruises={cruisesData}
    />
  );
}

AllMyCruisesWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/allmycruises';
export default AllMyCruisesWrapper;
